import Modal from './../../components/modal';

const QrModal = props => {
  const { onDismiss } = props;
  return (
    <Modal onDismiss={onDismiss} bottomBorderRemove={true} title=" ">
      <div className="lil-text-center">
        <h2 className="lil-text-s-40 lil-mb-2 lil-mt-2 lil-mx-auto">
          Scan to download
        </h2>
        <p className="lil-mb-10 lil-px-4">
          Please scan QR code with your phone’s camera to download
          <span className="lil-font-black"> Black</span>
        </p>
        <img
          className="lil-mb-10 lil-mx-auto"
          src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1630580223_qrblackapp.png"
          width="240"
          height="auto"
          alt="QR_code"
        ></img>
        <button
          onClick={onDismiss}
          className="lil-cursor-pointer lil-py-3 lil-mb-5 lil-px-10 lil-mx-auto lil-bg-blue-350 lil-font-bold lil-text-white lil-rounded-lg"
        >
          Done
        </button>
      </div>
    </Modal>
  );
};

export default QrModal;



// WEBPACK FOOTER //
// ./components/common/qrModal.tsx